import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-4" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Please Enter user name and password to login")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "(For Existing Users)")
  ])
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 text-center" }
const _hoisted_6 = { class: "row mt-4 mb-4" }
const _hoisted_7 = { class: "col-12 text-center" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, [
      /*#__PURE__*/_createTextVNode("(Not Existing User? Please "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#/register",
        style: {"color":"red","text-decoration":"underline"}
      }, "Resgister"),
      /*#__PURE__*/_createTextVNode(")")
    ])
  ])
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 text-center h3 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
            placeholder: "Enter Username"
          }, null, 512), [
            [_vModelText, $setup.userName]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, [
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
            placeholder: "Enter Password"
          }, null, 512), [
            [_vModelText, $setup.password]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
          }, "Login")
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", null, _toDisplayString($setup.loginResult), 1)
      ])
    ])
  ]))
}